<!--
 * @Author: FengXiao
 * @Date: 2020-07-14 15:10:28
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:48:24
-->
<template>
  <div class="speech-detail-page page-container">
    <video-player
      :datas="videoData"
      :speaker="speaker"
      :allowEvent.sync="playerAllowEvent"
	  :viplock="vip_lock"
      :collect="miniTabActive[HEART_ID]"
      @clickCollect="onClickMiniTab(HEART_ID)"
    ></video-player>
	<div class="content">
		<div class="speechother">
			<episode-list
					:title="topic.title" 
					:datas="episodeList" 
					:init-slide="initSlide"
					v-if="episodeList.length"
						@select="onSelectEpisode"></episode-list>
		</div>
		<div class="speechContent">
		<div class="left-bl clearfix">
        <transition name="el-fade-in-linear">
          <div class="child-bl" v-html="draft" v-show="miniTabActive[DOC_ID]"></div>
        </transition>
        <transition name="el-fade-in-linear">
          <comment-list
            class="child-bl"
            :topic="topic"
            type="speech"
			:videotype="videotype"
            :id="speechId"
            v-show="!miniTabActive[DOC_ID]"
            @inputFocus="inputFocus"
          ></comment-list>
        </transition>
      </div>
      <div class="right-bl">
        <mini-tabs @onClickTab="onClickMiniTab" :active="miniTabActive" v-show="videotype !== 10"></mini-tabs>
        <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
      </div>
	  </div>
    </div>
	<buyvipDialog :payPopup="payPopup" v-show="payPopup" @close="close"></buyvipDialog>
 <buyvipResultDialog :payresPopup="payresPopup" v-show="payresPopup" :order_num="order_num" :order_status="order_status" :buy_type="buy_type" @closeres="closeres"></buyvipResultDialog>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import CommentList from '@/components/AppCommentList';
import 'element-ui/lib/theme-chalk/base.css';
import RecommendVideos from '@/components/AppRecommendVideos';
import MiniTabs from '@/components/AppMiniTabs';
import requestApi from '@/service';
import buyvipResultDialog from '@/components/buy_vipResultDialog.vue';
import buyvipDialog from '@/components/buy_vipDialog.vue';
import EpisodeList from '@/components/AppEpisodeList';
import { mapState } from 'vuex';

import configFields from '@/utils/configFields';
const { DOC_ID, HEART_ID, DRAFT_TYPE } = configFields;
export default {
  name: 'SpeechDetail',
  components: {
    VideoPlayer,
    CommentList,
    RecommendVideos,
    MiniTabs,
	buyvipResultDialog,
	EpisodeList,
	buyvipDialog,
  },
  data() {
    return {
      videoData: {},
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      showHeart: false,
      showDoc: false,
      recommendList: [],
      topic: {},
      draft: '',
      DOC_ID,
      HEART_ID,
      miniTabActive: {},
      speechId: '',
	  videotype:'',
	  payresPopup: false,
	  order_num:'',
	  buy_type:'',
	  order_status:1,//订单状态
	  episodeList:[],
	  vip_lock:false,
	  payPopup: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/speech/detail') {
        this.init();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
	  if((from.path === '/' || !from.path) && to.query.id && to.query.order_num && to.query.buy_type) {
		  	window.$router.replace({
				name: 'SpeechDetail',
				query:{id:to.query.id},
		  		params: {
					id:to.query.id,
		  		  order_num: to.query.order_num,
		  		  buy_type: to.query.buy_type,
		  		},
		  	})
	  }else {
		next(vm => {
			if (to.params.id && to.params.order_num && to.params.buy_type) {
				vm.check_order(to.params.order_num,to.params.buy_type);
			}
		})
	  }
  },
  computed:{
	  ...mapState(['vipInfo']),
	  initSlide() {
	  	let index = 0;
	  	for (let i = 0; i < this.episodeList.length; i++) {
	  		if (this.episodeList[i].id === this.speechId) {
	  			index = i;
	  			break;
	  		}
	  	}
	  	return index;
	  },
  },
  methods: {
	  //判断时候支付成功
	  check_order(ordernum,buytype) {
	  	this.order_num = ordernum
	  	this.buy_type = buytype
	  	requestApi('/v3/api/h5/order/wanxiang/',
	  	{order_num:this.order_num,
	  	is_pc:1,
	  	buy_type:this.buy_type,},
	  	'GET').then(res => {
	  		if(res.msg == '等待支付') {
	  			
	  		}else {
				this.order_num = ordernum
				this.buy_type = buytype
	  			this.order_status = 2
	  			this.payresPopup = true
	  		}
	  	});
	  },
	  closeres(val) {
	  	this.payresPopup = false
	  },
    init() {
      Object.assign(this.$data, this.$options.data());
      this.speechId = +this.$route.query.id;
	  this.videotype = +this.$route.query.videotype ;
      this.miniTabActive = {
        [DOC_ID]: false,
        [HEART_ID]: false,
      };
      // this.getDetail();
	  this.getspeechDetail();
      this.getRecommend();
      this.initScrollTop();
    },
	getspeechDetail() {
		requestApi('/v3/api/h5/play_detail/',
		{video_type:this.videotype || "0",
		video_id:this.speechId,
		album_id:0,},
		'GET').then(res => {
			if(res.base_items.member_type == 2) {
				if(!this.vipInfo.status ) {
					// console.log(2)
					this.vip_lock = true
				}
			}
			this.episodeList = res.speech_choice_items
			this.speaker = res.base_items.speaker;
			this.videoData = {
			  cover:res.base_items.video_cover,
			  videoUrls: res.base_items.video_url,
			  intro: res.base_items.intro,
			  member_type: res.base_items.member_type,
			};
			this.topic = {
			  title:res.base_items.title,
			  category:res.base_items.videocate_items[0],
			  date:res.base_items.created,
			  city:res.base_items.city,
			  intro:res.base_items.intro,
			};
			if(res.base_items.is_collect == 0) {
				this.miniTabActive[HEART_ID] = false
			}else {
				this.miniTabActive[HEART_ID] = true
			}
			console.log(this.vip_lock)
		})
	},
    getDetail() {
      const url = `/api/site/speech/${this.speechId}/detail/`;
      requestApi(url).then(({ speech }) => {
        const { speaker, video_url, cover, titlelanguage, title, first_category, date, city, audio_duration, audio_url, is_collect } = speech;
		this.speaker = speaker;
        this.videoData = {
          cover,
          videoUrls: video_url,
          intro: titlelanguage,
        };
        this.topic = {
          title,
          category: first_category,
          date,
          city,
          intro: titlelanguage,
        };
        this.audioData = {
          duration: audio_duration,
          url: audio_url,
        };
        this.miniTabActive[HEART_ID] = is_collect;
      });
    },
    getRecommend() {
      const url = `/api/site/speech/${this.speechId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        if (recommended && recommended.length) {
          this.recommendList = recommended.map(item => {
            item.category = item.first_category;
            return item;
          });
        } else {
          this.recommendList = [];
        }
      });
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft() {
      return new Promise(resolve => {
        requestApi('/api/site/draft/', {
          id: this.speechId,
          type: DRAFT_TYPE.speech,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    /**
     * @description: 显示文稿
     * @param {type}
     * @return:
     */
    showDocFn(val) {
      this.showDoc = val;
    },
    /**
     * @description: 显示收藏
     * @param {type}
     * @return:
     */
    showHeartFn(val) {
      if (!this.$store.state.token) {
        this.$router.push('/userCenter');
        return;
      }
      this.showHeart = val;
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id,
        },
      });
    },
    onClickMiniTab(id) {		
      if (id === DOC_ID) {
		if(this.vip_lock) {
			if(this.checkLogin()) {
				return this.payPopup = true
			}
		}
        if (!this.draft) {
          this.getDarft().then(res => {
            if (res) {
              this.miniTabActive[id] = !this.miniTabActive[id];
            }
          });
        } else {
          this.miniTabActive[id] = !this.miniTabActive[id];
        }
      } else if (id === HEART_ID) {
        if (this.checkLogin()) {
          this.collect().then(() => {
            this.miniTabActive[id] = !this.miniTabActive[id];
          });
        }
      }
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    /**
     * @description: 收藏
     */
    collect() {
      return requestApi(
        '/v3/api/v1/collection/change/',
        {
          video_id: this.speechId,
		  video_type:this.videotype || "0",
		  type:1,
        },
        'POST'
      );
    },
	onSelectEpisode(data) {
		this.gotoSpeechother(data.id,data.video_type)
	},
	gotoSpeechother(id,videotype) {
		this.$router.push({
			path: '/speech/detail',
			query: {
				id,
				videotype,
			},
		});
	},
	close(val) {
		this.payPopup = false
	},
	
  },
};
</script>

<style lang="scss" scoped>
.speech-detail-page {
  .speechContent {
    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;
    .left-bl {
      width: 72%;
      max-width: 827px;
      margin-right: 10px;
      box-sizing: border-box;
      background: $C1;
      padding: 0 40px;
      position: relative;
      .child-bl {
        float: left;
        left: 0;
        top: 0;
        width: 100%;
      }
    }
    .right-bl {
      width: 28%;
      background-color: $C10;
    }
  }
}
</style>
